var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "elabel-export pa-4 pa-md-8",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "export-content"
  }, [_c('header', {
    staticClass: "d-flex align-center mb-6"
  }, [_c('v-btn', {
    staticClass: "ml-n3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.goToProducts
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("mdi-arrow-left")])], 1), _c('div', {
    staticClass: "page-title mono"
  }, [_vm._v(_vm._s(_vm.$t('elabel_export_title')))]), _c('v-spacer'), _vm.helpCenterLink ? _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "content-class": "hint-tooltip",
      "close-delay": 2000
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-icon', _vm._g(_vm._b({
          staticClass: "help-icon mr-3"
        }, 'v-icon', attrs, false), on), [_vm._v("mdi-information-outline")])];
      }
    }], null, false, 661989641)
  }, [_c('a', {
    attrs: {
      "href": _vm.helpCenterLink,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.openHelpCenterArticle(_vm.helpCenterLink);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('elabel_export_help_link')) + " ")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.loadingCampaigns,
      "data-test": "open-export-dialog"
    },
    on: {
      "click": function ($event) {
        _vm.dialogOpen = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('elabel_export_create')) + " ")])], 1), _c('v-card', {
    staticClass: "history-card",
    attrs: {
      "outlined": ""
    }
  }, [_c('h2', {
    staticClass: "history-title px-4 pt-4 pt-md-6 pb-1"
  }, [_vm._v(_vm._s(_vm.$t('elabel_export_history')))]), _c('p', {
    staticClass: "history-hint px-4 mb-4",
    attrs: {
      "data-test": "history-hint"
    }
  }, [_vm._v(_vm._s(_vm.$t('elabel_export_history_hint')))]), _vm.loadError ? _c('v-alert', {
    staticClass: "mx-4 mx-md-6",
    attrs: {
      "type": "error",
      "text": "",
      "data-test": "history-error"
    }
  }, [_vm._v(" " + _vm._s(_vm.loadError) + " "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "text": "",
      "color": "error"
    },
    on: {
      "click": function ($event) {
        return _vm.loadHistory();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('try_again')))])], 1) : _vm._e(), _c('v-data-table', {
    staticClass: "history-table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.exports,
      "loading": _vm.loading,
      "options": _vm.tableOptions,
      "server-items-length": _vm.totalCount,
      "items-per-page": _vm.PAGE_SIZE,
      "expanded": _vm.expandedJobs,
      "no-data-text": _vm.$t('elabel_export_not_found'),
      "item-key": "key",
      "disable-sort": "",
      "hide-default-footer": "",
      "data-test": "exports-table"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: `item.campaigns`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [!_vm.campaignNamesOf(item).length ? _c('span', {
          staticClass: "grey--text"
        }, [_vm._v("—")]) : _vm.isAllMarker(_vm.campaignNamesOf(item)) ? _c('span', {
          staticClass: "grey--text",
          attrs: {
            "data-test": 'all-campaigns-' + item.key
          }
        }, [_vm._v(_vm._s(_vm.$t('elabel_export_all_campaigns')))]) : [_vm._v(" " + _vm._s(_vm.leadingCampaignNames(item)) + " "), _vm.hiddenCampaignCount(item) ? _c('a', {
          staticClass: "more-link",
          attrs: {
            "href": "#",
            "data-test": 'more-' + item.key
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.toggleExpanded(item);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('plus_count_more', {
          count: _vm.hiddenCampaignCount(item)
        })) + " ")]) : _vm.isAllMarker(_vm.brandNamesOf(item)) ? _c('span', {
          staticClass: "grey--text ml-1",
          attrs: {
            "data-test": 'all-brands-' + item.key
          }
        }, [_vm._v(_vm._s(_vm.$t('brand_all_brands')))]) : _vm.brandNamesOf(item).length ? _c('a', {
          staticClass: "more-link",
          attrs: {
            "href": "#",
            "data-test": 'brands-' + item.key
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.toggleExpanded(item);
            }
          }
        }, [_vm._v(" + " + _vm._s(_vm.$tc('elabel_export_brand_count', _vm.nameCount(_vm.brandNamesOf(item)), {
          count: _vm.nameCount(_vm.brandNamesOf(item))
        })) + " ")]) : _vm._e()]];
      }
    }, {
      key: `item.products`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.productCountText(item)) + " ")];
      }
    }, {
      key: `item.created`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('span', {
          attrs: {
            "title": _vm.formatDateTime(item.created_at)
          }
        }, [_vm._v(_vm._s(_vm.formatDate(item.created_at)))])];
      }
    }, {
      key: `item.status`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('div', {
          staticClass: "status-cell",
          attrs: {
            "data-test": 'status-' + item.key
          }
        }, [_vm.canDownload(item) ? _c('div', [_vm._v(_vm._s(_vm.$t('elabel_export_valid_until', {
          date: _vm.formatDate(item.expires_at)
        })))]) : _vm.isActive(item) ? _c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-progress-circular', {
          staticClass: "mr-2",
          attrs: {
            "indeterminate": "",
            "size": "14",
            "width": "2",
            "color": "primary"
          }
        }), _vm._v(" " + _vm._s(_vm.$t('elabel_export_status_generating')) + " ")], 1) : _vm.canRetry(item) ? [_c('div', {
          staticClass: "job-error"
        }, [_vm._v(_vm._s(_vm.$t('elabel_export_status_error')))]), item.error_data && item.error_data.error_message ? _c('div', {
          staticClass: "error-note",
          attrs: {
            "title": item.error_data.error_message,
            "data-test": 'error-note-' + item.key
          }
        }, [_vm._v(" " + _vm._s(item.error_data.error_message) + " ")]) : _vm._e()] : _vm.isExpired(item) ? _c('div', {
          attrs: {
            "title": _vm.formatDate(item.expires_at)
          }
        }, [_vm._v(_vm._s(_vm.$t('expired')))]) : _c('div', [_vm._v(_vm._s(item.status))])], 2)];
      }
    }, {
      key: `item.action`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_vm.canDownload(item) ? _c('v-btn', {
          staticClass: "status-action",
          attrs: {
            "color": "primary",
            "loading": _vm.downloadingKey === item.key,
            "data-test": 'download-' + item.key
          },
          on: {
            "click": function ($event) {
              return _vm.download(item.key);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('download')) + " ")]) : _vm.canRetry(item) ? _c('v-btn', {
          staticClass: "status-action",
          attrs: {
            "outlined": "",
            "color": "primary",
            "loading": _vm.retryingKey === item.key,
            "data-test": 'retry-' + item.key
          },
          on: {
            "click": function ($event) {
              return _vm.retry(item.key);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('retry')) + " ")]) : _vm._e()];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref7) {
        var rowHeaders = _ref7.headers,
          item = _ref7.item;
        return [_c('td', {
          staticClass: "expanded-panel px-4 px-md-6 py-3",
          attrs: {
            "colspan": rowHeaders.length
          }
        }, [_c('div', {
          staticClass: "caption text-uppercase grey--text text--darken-1 mb-1"
        }, [_vm._v(" " + _vm._s(_vm.$t('elabel_export_campaigns_included', {
          count: _vm.nameCount(_vm.campaignNamesOf(item))
        })) + " ")]), _c('p', {
          staticClass: "expanded-names mb-0"
        }, [_vm._v(_vm._s(_vm.namesLine(_vm.campaignNamesOf(item))))]), _vm.brandNamesOf(item).length ? [_c('div', {
          staticClass: "caption text-uppercase grey--text text--darken-1 mb-1 mt-3"
        }, [_vm._v(" " + _vm._s(_vm.$t('elabel_export_brands_included', {
          count: _vm.nameCount(_vm.brandNamesOf(item))
        })) + " ")]), _c('p', {
          staticClass: "expanded-names mb-0"
        }, [_vm._v(_vm._s(_vm.namesLine(_vm.brandNamesOf(item))))])] : _vm._e()], 2)];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.totalCount > 0,
            expression: "totalCount > 0"
          }],
          staticClass: "mt-5 mb-4"
        }, [_c('v-pagination', {
          attrs: {
            "length": _vm.pageCount,
            "total-visible": 7,
            "color": "primary",
            "data-test": "export-pagination"
          },
          model: {
            value: _vm.tableOptions.page,
            callback: function ($$v) {
              _vm.$set(_vm.tableOptions, "page", $$v);
            },
            expression: "tableOptions.page"
          }
        })], 1)];
      },
      proxy: true
    }], null, true)
  })], 1)], 1), _c('elabel-export-dialog', {
    attrs: {
      "campaigns": _vm.campaigns,
      "single-campaign": _vm.singleCampaign,
      "submitting": _vm.submitting
    },
    on: {
      "submit": _vm.submit
    },
    model: {
      value: _vm.dialogOpen,
      callback: function ($$v) {
        _vm.dialogOpen = $$v;
      },
      expression: "dialogOpen"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }